import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import some from 'lodash/some'

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { TabMenu } from 'primereact/tabmenu';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputSwitch } from 'primereact/inputswitch';


import CategorieSectionDocumentTree from '@components/CategorieSectionDocumentTree';

import { SET_VALUES_DOCUMENT } from '@constants/actionType';
import { LANGUAGE_DEFAULT } from '@constants/general';
import { TypeDocuments, documentsExceptionsDelete } from '@constants/documents'

import store from '@store';

// import './style.scss'

class GeneralForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNavegationTree: '',
      selectedLabelNavegationTree: '',
      publicationDate: null,
      typeDocument: TypeDocuments.IS_LINK,
      activeTabIndex: 0,
      loadingPage: true,
      errors: {},
      documentExceptionChangeType: false,
      mandatoryReading: false,
    };
    this.initialValuesForm = {
      name: '',
      description: '',
      keywords: ''
    };
    this.minDate = new Date();
  }

  componentDidMount() {
    const {
      keysLenguages,
      _general,
      history,
      documentId,
      _obligatory
    } = this.props;
    console.log('history', history)
    
    if (history.location?.state?.selectedNavegationTree && history.location?.state?.selectedNavegationTree !== 10) {
      this.setState({selectedNavegationTree: history.location?.state?.selectedNavegationTree})
    }

    if (_general) {
      this.setState({
        ..._general,
      });
    } else {
      keysLenguages.map((item) =>
        this.setState({ [item]: { ...this.initialValuesForm } })
      );
    }

    if (_obligatory) {
      this.setState({
        ..._obligatory
      });
    }
    if (documentsExceptionsDelete.find(item => item === documentId)) this.setState({documentExceptionChangeType: true})
    this.setState({ loadingPage: false });
  }

  onChangeCategoriesSection = ({ value, label }) => {
    this.setState({
      selectedNavegationTree: value,
      selectedLabelNavegationTree: label,
    }, () => this.validateFieldsOnchange('selectedNavegationTree', value));
  };

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }), () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeSimple = ({ target }) => {
    this.setState(
      { [target.name]: target.value },
      () => this.validateFieldsOnchange(target.name, target.value));
  };

  onChangeCheckbox = (e) => {
    this.setState({[e.target.name]: e.checked});
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFields = async () => {
    const { t } = this.props
    const { publicationDate, selectedNavegationTree } = this.state
    const { name, description, keywords } = this.state[LANGUAGE_DEFAULT]
    let errors = {}
    // if (!publicationDate) errors = {...errors, [`publicationDate`]: `${t('Fecha de publicación')} ${t('es requerido')}`}
    if (!name) errors = {...errors, [`${LANGUAGE_DEFAULT}-name`]: `${t('Nombre')} ${t('es requerido')}`}
    if (!description) errors = {...errors, [`${LANGUAGE_DEFAULT}-description`]: `${t('Descripción')} ${t('es requerido')}`}
    if (!keywords) errors = {...errors, [`${LANGUAGE_DEFAULT}-keywords`]: `${t('Palabras clave')} ${t('es requerido')}`}
    if (!selectedNavegationTree) errors = {...errors, [`selectedNavegationTree`]: `${t('Sección Padre')} ${t('es requerido')}`}

    this.setState({errors})
    return errors
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const validate = await this.validateFields()
    if (some(validate, {})) return true
    const { success, keysLenguages, _obligatory } = this.props;
    const {  typeDocument, selectedLabelNavegationTree, selectedNavegationTree, mandatoryReading } = this.state;
    const getValues = keysLenguages.reduce((accum, item) => {
      let values = this.state[item]
      values.name = values.name.trim()
      accum[item] = values;
      return accum;
    }, {});

    await store.dispatch({
      type: SET_VALUES_DOCUMENT,
      payload: {
        general: {...getValues, typeDocument, selectedLabelNavegationTree, selectedNavegationTree},
        obligatory: { ..._obligatory, mandatoryReading }
      },
    });
    success();
  };

  render() {
    const { t, btnSubmitLoading, history, itemsTabsLenguages, keysLenguages, isEdit } = this.props;

    const {
      selectedNavegationTree,
      selectedLabelNavegationTree,
      activeTabIndex,
      loadingPage,
      errors,
      typeDocument,
      publicationDate,
      documentExceptionChangeType,
      mandatoryReading
    } = this.state;

    const isFormFieldValid = (name) =>
      !!(errors[name]);
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
        <>
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Nombre', {lng: prefixLenguage })}
            </label>
            <InputText
              name={`${prefixLenguage}-name`}
              type="text"
              value={this.state[prefixLenguage].name}
              onChange={this.onChange}
              autoFocus
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-name`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-name`)}
          </div>
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Descripción', {lng: prefixLenguage })}
            </label>
            <InputTextarea
              name={`${prefixLenguage}-description`}
              rows={5}
              cols={30}
              value={this.state[prefixLenguage].description}
              onChange={this.onChange}
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-description`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-description`)}
          </div>
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Palabras clave', {lng: prefixLenguage })}
            </label>
            <InputText
              name={`${prefixLenguage}-keywords`}
              type="text"
              value={this.state[prefixLenguage].keywords}
              onChange={this.onChange}
              autoFocus
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-keywords`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-keywords`)}
          </div>
          {/* <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              {t('Palabras clave', {lng: prefixLenguage })}
            </label>
            <Chips
              name={`${prefixLenguage}-keywords`}
              type="text"
              value={this.state[prefixLenguage].keywords}
              onChange={this.onChange}
              autoFocus
              className={classNames({
                'p-invalid': isFormFieldValid(`${prefixLenguage}-keywords`),
              })}
            />
            {getFormErrorMessage(`${prefixLenguage}-keywords`)}
            <br/>
            {t('Da ENTER para finalizar la palabra')}
          </div> */}
        </>
      );
    };

    if (loadingPage) return true;
    return (
      <form onSubmit={this.onSubmit} autoComplete="false">
        <div className="p-fluid p-grid p-mb-4">
          <div className="p-col-12 p-d-flex p-ai-center">
            <label className="p-text-bold p-mr-2">{t('Sección Padre')}</label>
            <div className={classNames({'is-display-none': isEdit})}>
              <CategorieSectionDocumentTree
                value={selectedNavegationTree}
                label={selectedLabelNavegationTree}
                onChangeCategorie={this.onChangeCategoriesSection}
                notSelectDocument
              />
            </div>
            { isEdit && <a>{selectedLabelNavegationTree || "N/A"}</a> }
          </div>
          <div className="p-col-12" style={{marginTop: "-19px"}}>
          {getFormErrorMessage(`selectedNavegationTree`)}
          </div>
          <div className="p-col-12 p-field">
            <div className="p-field-radiobutton">
              <InputSwitch
                name="mandatoryReading"
                value
                onChange={this.onChangeSimple}
                checked={mandatoryReading}
              />
              <label className="p-text-bold">{t('El documento es de lectura obligatoria')}</label>
            </div>
          </div>
          <div className="p-col-12 p-md-6 p-lg-6">
            <label htmlFor="icon" className="p-text-bold">{t('Fecha de publicación')}</label>
            <div className="p-field-radiobutton p-mt-2">
                <RadioButton
                  inputId="typeDocument1"
                  name="typeDocument"
                  value={TypeDocuments.IS_LINK}
                  onChange={this.onChangeSimple}
                  checked={typeDocument === TypeDocuments.IS_LINK}
                  disabled={documentExceptionChangeType}
                />
                <label className="p-pr-3" htmlFor="typeDocument1">{t('Link')}</label>
              </div>
              <div className="p-field-radiobutton">
                <RadioButton
                  inputId="typeDocument2"
                  name="typeDocument"
                  value={TypeDocuments.IS_DOCUMENT_PDF}
                  onChange={this.onChangeSimple}
                  checked={typeDocument === TypeDocuments.IS_DOCUMENT_PDF}
                  disabled={documentExceptionChangeType}
                />
                <label htmlFor="typeDocument2">{t('Documento PDF')}</label>
              </div>
              <div className="p-field-radiobutton p-mb-2">
                <RadioButton
                  inputId="typeDocument3"
                  name="typeDocument"
                  value={TypeDocuments.IS_FORMATTED_TEXT}
                  onChange={this.onChangeSimple}
                  checked={typeDocument === TypeDocuments.IS_FORMATTED_TEXT}
                  disabled={documentExceptionChangeType}
                />
                <label htmlFor="typeDocument3">{t('Texto con formato')}</label>
              </div>
          </div>

          {/* <div className="p-col-12 p-md-6 p-lg-6">
            <label htmlFor="icon" className="p-text-bold">{t('Fecha de publicación')}</label>
            <Calendar
              id="icon"
              name="publicationDate"
              value={publicationDate}
              onChange={this.onChangeSimple}
              minDate={this.minDate}
              showIcon
              className={classNames({
                'p-invalid': isFormFieldValid(`publicationDate`),
              })}
            />
            {getFormErrorMessage(`publicationDate`)}
          </div> */}
          <div className="p-col-12">
            {itemsTabsLenguages && (
              <TabMenu
                model={itemsTabsLenguages}
                activeIndex={activeTabIndex}
                onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
              />
            )}
          </div>
          {renderByTabLenguage()}
        </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-between">
            <Button
              label={t('Cancelar')}
              type="button"
              className="p-button-secondary"
              onClick={() => history.push('/documents')}
            />
            <Button
              label={t('Continuar')}
              type="submit"
              className="p-button-primary"
              loading={btnSubmitLoading}
            />
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  _general: state.document.general,
  documentId: state.document.id,
  workstationCatalog: state.catalogs.workstationsCurrentCatalog,
  _obligatory: state.document.obligatory,
});

export default withRouter(compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(GeneralForm));
